import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FirestoreModule } from '../modules/firestore.module';
import { AuthRoutingModule } from './auth.routing';
import { LoginComponent } from './components/login/login.component';


/**
 * Modulo de autenticacion
 */
@NgModule({
  declarations: [LoginComponent],
  exports: [
    FirestoreModule
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FirestoreModule,
    AuthRoutingModule
  ]
})
export class AuthModule { }
